import React, { memo } from 'react';
import { Cell, Button, Tooltip, colors } from '@dexma/ui-components';

import gtmIds from 'adapter/in/dashboards/config/gtm';
import { StyledDashboardHeader, StyledTagPinDashboard } from 'adapter/in/dashboards/pages/Dashboard/Header/style';
import i18n from 'asset/translation';
import Branding from 'domain/entity/branding';
import { DashboardActionsDropdown } from 'adapter/in/dashboards/components/DashboardActionsDropdown/DashboardActionsDropdown';
import Dashboard from 'domain/entity/dashboard';

export type DashboardHeaderType = {
    dashboard: Dashboard;
    pinned: boolean;
    branding: Branding;
    fullscreenActive: boolean;
    onBack: () => void;
    onFullscreen: () => void;
    onDeleteSuccess: () => void;
    onDuplicateSuccess: () => void;
    onShareSuccess: () => void;
    onPinSuccess: (pinned: boolean) => void;
};

const DashboardHeader = memo((props: DashboardHeaderType) => {
    const {
        dashboard,
        pinned,
        branding,
        fullscreenActive,
        onBack,
        onFullscreen,
        onDeleteSuccess,
        onDuplicateSuccess,
        onShareSuccess,
        onPinSuccess,
    } = props;
    return (
        <StyledDashboardHeader data-testid='dashboard-header'>
            <Cell xs={10}>
                {pinned && (
                    <div>
                        <Tooltip title={i18n.t('dashboards.pinned.tooltip.info')}>
                            <StyledTagPinDashboard
                                data-testid='pinned-dashboard'
                                variant='primary'
                                color={branding ? branding.primaryColor : colors.teal}
                                icon='push_pin'
                            >
                                {i18n.t('dashboards.pinned.tag')}
                            </StyledTagPinDashboard>
                        </Tooltip>
                    </div>
                )}
                <div className='menu-dashboard'>
                    <Button
                        variant='icon-secondary'
                        iconBefore='arrow_left'
                        isCircle
                        onClick={onBack}
                        dataId={gtmIds.dashboard.returnToDashboards}
                        data-testid='dashboards-go-back-icon-button'
                    />
                    <span className='name'>{dashboard.name}</span>
                </div>
            </Cell>
            {!fullscreenActive && (
                <Cell xs={2} className='menu-settings'>
                    <Button
                        data-testid='fullscreen-button'
                        iconAfter='fullscreen'
                        variant='icon-secondary'
                        isCircle
                        onClick={onFullscreen}
                        dataId={gtmIds.dashboardLink.actions.fullscreen}
                    />
                    <DashboardActionsDropdown
                        dashboard={dashboard}
                        hasPinnedDashboard={false}
                        onDeleteModalSuccess={onDeleteSuccess}
                        onDuplicateModalSuccess={onDuplicateSuccess}
                        onPinModalSuccess={onPinSuccess}
                        onShareModalSuccess={onShareSuccess}
                        withDuplicateRedirection
                    />
                </Cell>
            )}
        </StyledDashboardHeader>
    );
});

export default DashboardHeader;
